import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper } from '@material-ui/core';
import Filter from '../../../components/Dashboard/Filter/Date';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import EmptyChart from '../../../components/Dashboard/Chart/EmptyChart';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

const PointAndRedeem = () => {
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingGraph, setIsLoadingGraph] = useState(false);
   const [chartData, setChartData] = useState();
   const [filtersData, setFiltersData] = useState();
   const location = useLocation();
   const getChartsOptionsDefault = () => {
      let option = {
         gradientColor: ['#defffd', '#96f6ff', '#00eaff'],
         tooltip: {
            position: 'top',
         },
         grid: {
            top: 10,
            left: 10,
            right: 10,
            bottom: 10,
            containLabel: true,
         },
         xAxis: {
            type: 'category',
            data: null,
            splitArea: {
               show: true,
            },
            axisLabel: { rotate: 90 },
         },
         yAxis: {
            type: 'category',
            data: null,
            splitArea: {
               show: true,
            },
         },
         visualMap: {
            show: false,
            min: 0,
            max: 10,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            bottom: '5%',
         },
         series: [
            {
               name: 'Punch Card',
               type: 'heatmap',
               data: null,
               label: {
                  show: true,
               },
               emphasis: {
                  itemStyle: {
                     shadowBlur: 10,
                     shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
               },
            },
         ],
      };
      return option;
   };
   const onFiltersSubmit = (filters) => {
      setFiltersData(filters);
      let payload = {
         startDate: filters.startDateString,
         endDate: filters.endDateString,
      };
      setIsLoadingGraph(true);
      Axios.get('/GSB/dashboard/dashboard/GetEmployeeLogin', {
         params: payload,
      })
         .then((resp) => {
            setChartData(resp.data.employeeLogin);
            // enqueueSnackbar('ดึงข้อมูลกราฟสำเร็จ', { variant: 'success' })
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoadingGraph(false);
         });
   };
   const mapOptions = (data) => {
      let days = data.map(
         (el) => `${el.dateInWeek}, ${el.dateTimeLabel.split(' ')[0]}`,
      );

      let hours = data[0].data.map(
         (el) => `${el.startHourLabel}-${el.endHourLabel}`,
      );

      let index = 0;
      let restructureData = [];
      data.forEach((element) => {
         element.data.forEach((el) => {
            restructureData[index++] = el.count;
         });
      });

      let temp = [[]];
      let dayCount = 1;
      let hrsCount = 0;
      for (let i = 1; i <= data.length * 24; i++) {
         temp[i - 1] = [dayCount - 1, hrsCount, restructureData[i - 1]];
         hrsCount += 1;
         if (i % 24 === 0) {
            dayCount += 1;
         }
         if (hrsCount === 24) {
            hrsCount = 0;
         }
      }

      const dataMapped = temp.map(function (item) {
         return [item[1], item[0], item[2] || '-'];
      });

      let option = getChartsOptionsDefault();
      option.visualMap.min = Math.min(...restructureData);
      option.visualMap.max = Math.max(...restructureData);
      option.series[0].data = dataMapped;
      option.yAxis.data = days;
      option.xAxis.data = hours;

      return option;
   };
   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoadingGraph}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({ filtersData, chartData }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper>
            <Box padding={'10px'}>
               <Typography variant='h5'>แสดงจำนวนผู้เข้าใช้งาน</Typography>
               <Filter
                  isLoading={isLoadingGraph}
                  onSubmit={onFiltersSubmit}
                  defaultSubmitFirstParams
                  startDate={new Date(moment().subtract(6, 'days'))}
                  endDate={new Date()}
               />
               <Box textAlign={'end'} mb={'10px'}></Box>
            </Box>
            <Box padding={'10px'}>
               {chartData ? (
                  <ReactECharts
                     option={mapOptions(chartData)}
                     style={{
                        height: chartData.length * 40,
                        minHeight: 200,
                        width: '100%',
                     }}
                  />
               ) : (
                  <EmptyChart
                     text={'ไม่มีข้อมูล, โปรดระบุตัวกรองด้านบนเพื่อแสดงกราฟ'}
                     show={true}
                     height={300}
                  />
               )}
            </Box>
         </Paper>
      </div>
   );
};

export default PointAndRedeem;
